import { useState, useEffect } from 'react';
import { expenseRequestsAPI } from '@/lib/api';
import { useExpenseRole } from '@/lib/useExpenseRole';
import { BellRing, X } from 'lucide-react';

const SEEN_KEY = 'accounts_queue_seen_at';

export const AccountsAlertBanner = ({ onReview, className = 'mx-4 md:mx-8 lg:mx-12 mt-4' }) => {
  const role = useExpenseRole();
  const [queue, setQueue] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!role.is_reviewer) return undefined;
    const load = () => expenseRequestsAPI.accountsQueue(localStorage.getItem(SEEN_KEY)).then(r => setQueue(r.data)).catch(() => {});
    load();
    const timer = setInterval(load, 60000);
    return () => clearInterval(timer);
  }, [role.is_reviewer]);

  if (!role.is_reviewer || !queue || queue.count === 0 || hidden) return null;
  const newCount = queue.new_count || 0;

  const review = () => {
    localStorage.setItem(SEEN_KEY, queue.latest_at || new Date().toISOString());
    setHidden(true);
    onReview();
  };

  return (
    <div className={`${className} rounded-md border border-violet-500/40 bg-violet-500/10 px-4 py-3 flex items-center gap-3`} data-testid="accounts-alert-banner">
      <BellRing className={`w-5 h-5 text-violet-400 shrink-0 ${newCount > 0 ? 'animate-bounce' : ''}`} />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold text-foreground" data-testid="accounts-alert-count">
          {queue.count} {queue.count === 1 ? 'entry' : 'entries'} waiting for your verification · ₹{Math.round(queue.total).toLocaleString('en-IN')}
          {newCount > 0 && <span className="ml-2 text-[10px] uppercase bg-violet-500 text-white rounded px-1.5 py-0.5">{newCount} new</span>}
        </p>
        <p className="text-xs text-muted-foreground truncate">
          {queue.items.slice(0, 3).map(i => `${i.for_employee_name || i.employee_name} ₹${i.amount.toLocaleString('en-IN')}`).join(' · ')}
        </p>
      </div>
      <button onClick={review} className="px-3 py-1.5 rounded-md bg-violet-500 hover:bg-violet-600 text-white text-xs font-bold transition-colors shrink-0" data-testid="accounts-alert-review-btn">Review now</button>
      <button onClick={() => setHidden(true)} className="p-1 rounded hover:bg-muted transition-colors" data-testid="accounts-alert-dismiss"><X className="w-4 h-4 text-muted-foreground" /></button>
    </div>
  );
};
